import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import classNames from "classnames";
import PlayList24 from "@carbon/icons-react/lib/playlist/24";
import { EventStatus } from "@prestosports/prestostats-core/Common";
import { useGameContext } from "../../../state/game/context";
import gameContainerStyles from "../styles/GameContainer.styles";
import commonStyles from "../../common/styles/Common.styles";
import PlaySequenceContainer from "./PlaySequenceContainer";
import GameSummary from "../components/GameSummary";
import PlayList from "../components/PlayList";
import { useEventContext } from "../../../state/events/context";

const PlayListBtn = ({ onClick, open }) => {
	const classes = gameContainerStyles();

	return (
		<IconButton
			aria-label="View play list"
			onClick={onClick}
			className={classNames(classes.mobilePlayListBtn, {
				[classes.mobilePlayListDrawerBtn]: !open
			})}
		>
			<PlayList24 />
		</IconButton>
	);
};

const GameContainer = () => {
	const mdScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
	const commonClasses = commonStyles();
	const classes = gameContainerStyles();
	const [playlistOpen, setPlaylistOpen] = useState(false);

	const { state: gameState } = useGameContext();
	const game = gameState.game();

	const { state: eventState } = useEventContext();
	const canEditCurrentEvent = eventState.canEditCurrentEvent();
	const currentEvent = eventState.currentEvent();
	const isFinal = EventStatus.isFinal(currentEvent);

	const handleDrawerClose = () => {
		setPlaylistOpen(false);
	};

	return (
		<div className={classes.root}>
			<div className={classes.content}>
				{mdScreen && <PlayListBtn onClick={() => setPlaylistOpen(true)} open />}
				<Box className={classes.gameSummaryContainer}>
					{game && <GameSummary game={game} />}
				</Box>
				{canEditCurrentEvent && (
					<Box className={commonClasses.infoContainer}>
						<PlaySequenceContainer />
					</Box>
				)}
				{!canEditCurrentEvent && (
					<Box
						className={commonClasses.infoContainer}
						style={{
							paddingTop: 10
						}}
					>
						<PlayList groupByPeriod />
					</Box>
				)}
			</div>
			{!isFinal && (
				<SwipeableDrawer
					onOpen={() => {}}
					onClose={handleDrawerClose}
					className={classes.drawer}
					variant={mdScreen ? "temporary" : "permanent"}
					anchor="right"
					open={playlistOpen}
					classes={{
						paper: classNames(classes.drawerPaper, {
							[classes.drawerPaperMobile]: mdScreen
						})
					}}
				>
					{mdScreen && (
						<PlayListBtn onClick={() => setPlaylistOpen(false)} open={false} />
					)}
					{game && <PlayList />}
				</SwipeableDrawer>
			)}
		</div>
	);
};

export default GameContainer;
